module.exports = __webpack_public_path__ + "static/media/thumbnail.3fd3ebf8.jpg";